import { jointFrameColorLensImg } from "./lib";
import { imgUp } from "../upload";

export default class LensColorCanvas {
    w: any = 0;
    h: any = 0;
    canvas: any;
    tryon_canvas: any;
    newImg: any;
    bituoImg: any;
    jingjiaImg: any;
    color: any = [];
    color_img: any = "";
    imgPix: any = [];
    colorImg: any;
    time: any;

    init = ({
        productId,
        frame_image,
    }: {
        productId: number;
        frame_image: string;
    }) => {
        return new Promise<void>((resolve, reject) => {
            this.w = 600;
            this.h = 300;

            const canvas = document.createElement("canvas");
            const tryon_canvas = document.createElement("canvas");
            canvas.width = this.w;
            canvas.height = this.h;

            tryon_canvas.width = this.w;
            tryon_canvas.height = this.h;

            this.canvas = canvas;
            this.tryon_canvas = tryon_canvas;

            this.changeImg({ productId, frame_image })
                .then(() => {
                    resolve();
                })
                .catch((e) => reject(e));
        });
    };

    getImageTryOnImgAniMaster = () => {
        const ctx = this.tryon_canvas.getContext("2d");

        ctx.clearRect(0, 0, this.w, this.h);

        ctx.drawImage(this.bituoImg, 0, 0, this.w, this.h);
        ctx.drawImage(this.newImg, 0, 0, this.w, this.h);

        return this.tryon_canvas.toDataURL("image/png");
    };

    ImageLoadAll = ({ img, bituo_img, jingjia_img }: any) => {
        return new Promise<void>((resolve, reject) => {
            const promises = [];
            promises.push(this.ImageLoad(img));
            promises.push(this.ImageLoad(bituo_img));
            promises.push(this.ImageLoad(jingjia_img));

            Promise.all(promises).then((arg: any) => {
                resolve(arg);
            });
        });
    };

    changeImg = ({ productId, frame_image }: any) => {
        this.time = new Date().getTime();
        return new Promise<void>(async (resolve, reject) => {
            let img = jointFrameColorLensImg({
                productId: productId,
                name: frame_image,
                num: 1,
            });
            let bituo_img = jointFrameColorLensImg({
                productId: productId,
                name: frame_image,
                num: 2,
            });
            let jingjia_img = jointFrameColorLensImg({
                productId: productId,
                name: frame_image,
                num: 3,
            });

            let imgAll: any = await this.ImageLoadAll({
                img,
                bituo_img,
                jingjia_img,
            });

            this.newImg = imgAll[0];
            this.bituoImg = imgAll[1];
            this.jingjiaImg = imgAll[2];

            this.w = this.newImg.width / 2;
            this.h = this.newImg.height / 2;

            this.canvas.width = this.w;
            this.canvas.height = this.h;

            this.tryon_canvas.width = this.w;
            this.tryon_canvas.height = this.h;

            this.imgPix = [];
            resolve();
        });
    };

    ImageLoad = (img_src: string) => {
        return new Promise<void>((resolve, reject) => {
            let _Image: any = new Image();
            _Image.setAttribute("crossOrigin", "anonymous");
            _Image.onload = () => {
                resolve(_Image);
            };
            _Image.src = img_src;
        });
    };

    //镜片流程需要返回染色片图片
    getImageByColor = ({
        color,
        color_img,
    }: {
        color?: any;
        color_img?: string;
    }) => {
        return new Promise<void>(async (resolve, reject) => {
            this.color = color;
            this.color_img = color_img;
            if (color_img) {
                this.color_img = await this.ImageLoad(color_img);
            }
            this.draw((_img: any) => {
                const ctx = this.tryon_canvas.getContext("2d");

                ctx.clearRect(0, 0, this.w, this.h);

                let colorImg = new Image();
                colorImg.crossOrigin = "anonymous";
                colorImg.onload = () => {
                    ctx.drawImage(this.bituoImg, 0, 0, this.w, this.h);
                    ctx.drawImage(this.jingjiaImg, 0, 0, this.w, this.h);
                    ctx.drawImage(colorImg, 0, 0, this.w, this.h);
                    ctx.drawImage(this.newImg, 0, 0, this.w, this.h);

                    resolve(this.tryon_canvas.toDataURL("image/png"));
                };

                colorImg.src = _img;
            });
        });
    };

    pushColorImgToServer = () => {
        return new Promise<void>((resolve, reject) => {
            if (!this.tryon_canvas) {
                resolve();
                return;
            }

            const bytes = window.atob(
                this.tryon_canvas.toDataURL("image/png").split(",")[1],
            );
            //处理异常,将ascii码小于0的转换为大于0
            const ab = new ArrayBuffer(bytes.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            const dateT = new Date();
            let file = {
                name:
                    Math.random().toString(36).substr(2) +
                    (dateT.getFullYear() + dateT.getMonth() + dateT.getDate()),
                fileType: "png",
                type: "image/png",
            };
            const blob = new Blob([ab], { type: file.type });
            imgUp(file, true, blob).then(({ img, date }: any) => {
                resolve(img);
            });
        });
    };

    //试戴需要返回带鼻托的图片
    getImageTryOnImg = ({
        color,
        color_img,
    }: {
        color?: any;
        color_img?: string;
    }) => {
        return new Promise<void>(async (resolve, reject) => {
            this.color = color;
            this.color_img = color_img;
            if (color_img) {
                this.color_img = await this.ImageLoad(color_img);
            }

            this.draw((_img: any) => {
                const ctx = this.tryon_canvas.getContext("2d");

                ctx.clearRect(0, 0, this.w, this.h);

                let tryonImg = new Image();
                tryonImg.crossOrigin = "anonymous";
                tryonImg.onload = () => {
                    ctx.drawImage(this.bituoImg, 0, 0, this.w, this.h);
                    ctx.drawImage(tryonImg, 0, 0, this.w, this.h);
                    ctx.drawImage(this.newImg, 0, 0, this.w, this.h);

                    resolve(this.tryon_canvas.toDataURL("image/png"));
                };
                tryonImg.src = _img;
            });
        });
    };

    isSurroundedByOpaquePixels = (
        x: number,
        y: number,
        imageData: any,
    ): boolean => {
        const index = (y * this.w + x) * 4;
        const pixel = imageData.data.slice(index, index + 4);

        // Check if the pixel itself is transparent
        if (pixel[3] === 0) {
            return false;
        }

        // Check if there are opaque pixels above, below, left, and right of the given pixel
        const abovePixel =
            y > 0
                ? imageData.data.slice(
                      index - this.w * 4,
                      index - this.w * 4 + 4,
                  )
                : null;
        const belowPixel =
            y < this.h - 1
                ? imageData.data.slice(
                      index + this.w * 4,
                      index + this.w * 4 + 4,
                  )
                : null;
        const leftPixel = x > 0 ? imageData.data.slice(index - 4, index) : null;
        const rightPixel =
            x < this.w - 1 ? imageData.data.slice(index + 4, index + 8) : null;

        return (
            abovePixel &&
            abovePixel[3] > 0 &&
            belowPixel &&
            belowPixel[3] > 0 &&
            leftPixel &&
            leftPixel[3] > 0 &&
            rightPixel &&
            rightPixel[3] > 0
        );
    };

    getImagePix = () => {
        const ctx = this.canvas.getContext("2d");
        ctx.clearRect(0, 0, this.w, this.h);
        ctx.drawImage(this.newImg, 0, 0, this.w, this.h);
        let imageData = ctx.getImageData(0, 0, this.w, this.h);

        let pixiArr = imageData.data;

        let test = [];

        for (let row = 0; row < this.h; row++) {
            let left = row * 4 * this.w;
            //修复运动镜全框场景，中间有一竖条的时候遍历问题，多遍历5个像素
            let right = left + (4 * this.w) / 2 - 1 - 3;
            let leftF = false;
            let rightF = false;
            //为判断一个图片里面只有一个闭合空间的场景
            //判断起始点是否在闭合空间内，是的话不遍历
            if (isEnclosedSpace(this.w / 2 - 10, row, imageData)) {
                rightF = true;
            }
            while (!leftF || !rightF) {
                if (!leftF) {
                    if (pixiArr[left + 3] == 0) {
                        test.push(left);
                        left += 4;
                    } else leftF = true;
                }
                if (!rightF) {
                    if (pixiArr[right + 3] == 0) {
                        test.push(right);
                        right -= 4;
                    } else rightF = true;
                }
                if (left == right) {
                    leftF = true;
                    rightF = true;
                }
            }

            //修复运动镜全框场景，中间有一竖条的时候遍历问题，多遍历5个像素
            let left_2 = row * 4 * this.w + (4 * this.w) / 2 - 1 - 3;
            let right_2 = row * 4 * this.w + 4 * this.w - 1 - 3;
            let leftF_2 = false;
            let rightF_2 = false;
            //判断起始点是否在闭合空间内，是的话不遍历
            if (isEnclosedSpace(this.w / 2 + 10, row, imageData)) {
                leftF_2 = true;
            }
            while (!leftF_2 || !rightF_2) {
                if (!leftF_2) {
                    if (pixiArr[left_2 + 3] == 0) {
                        test.push(left_2);
                        left_2 += 4;
                    } else leftF_2 = true;
                }
                if (!rightF_2) {
                    if (pixiArr[right_2 + 3] == 0) {
                        test.push(right_2);
                        right_2 -= 4;
                    } else rightF_2 = true;
                }
                if (left_2 == right_2) {
                    leftF_2 = true;
                    rightF_2 = true;
                }
            }
        }

        // 同理进行列扫描
        for (let col = 0; col < this.w; col++) {
            let top = col * 4; // 指向列头
            let bottom = top + (this.h - 2) * this.w * 4 + this.w * 4; // 指向列尾
            let topF = false;
            let bottomF = false;
            while (!topF || !bottomF) {
                if (!topF) {
                    if (pixiArr[top + 3] == 0) {
                        test.push(top);
                        top += this.w * 4;
                    } else topF = true;
                }
                if (!bottomF) {
                    if (pixiArr[bottom + 3] == 0) {
                        test.push(bottom);
                        bottom -= this.w * 4;
                    } else bottomF = true;
                }

                if (top == bottom) {
                    topF = true;
                    bottomF = true;
                }
            }
        }

        this.imgPix = test;
        console.log("imgPix  time", new Date().getTime() - this.time);
    };

    draw = (resolve: any) => {
        if (!this.color && !this.color_img) {
            resolve("");
            return;
        }
        if (this.imgPix.length < 1) {
            this.time = new Date().getTime();
            this.getImagePix();
        }
        const ctx = this.canvas.getContext("2d");
        ctx.clearRect(0, 0, this.w, this.h);

        const gnt = ctx.createLinearGradient(0, 0, 0, this.h);

        if (this.color_img) {
            ctx.drawImage(this.color_img, 0, 0, this.w, this.h);
        } else {
            if (this.color.length == 1) {
                let color_1 = this.color[0];
                if (color_1[3] !== 0) {
                    gnt.addColorStop(
                        0,
                        `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},${color_1[3] ? color_1[3] : "0.9"})`,
                    );
                    gnt.addColorStop(
                        1,
                        `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},${color_1[3] ? color_1[3] : "0.9"})`,
                    );
                }
            }
            if (this.color.length == 2) {
                let color_1 = this.color[0];
                let color_2 = this.color[1];

                gnt.addColorStop(
                    0,
                    `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},${color_1[3] ? color_1[3] : "0.8"})`,
                );
                gnt.addColorStop(
                    0.3,
                    `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},${color_1[3] ? color_1[3] : "0.8"})`,
                );
                gnt.addColorStop(
                    0.9,
                    `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},0)`,
                );
                gnt.addColorStop(
                    1,
                    `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},0)`,
                );
                // gnt.addColorStop(1, `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]}, '0.2')`)
            }

            if (this.color.length == 3) {
                let color_1 = this.color[0];
                let color_2 = this.color[1];
                let color_3 = this.color[2];
                gnt.addColorStop(
                    0,
                    `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},1)`,
                );
                gnt.addColorStop(
                    0.2,
                    `rgba(${color_1[0]}, ${color_1[1]}, ${color_1[2]},${color_1[3] ? color_1[3] : "0.8"})`,
                );
                gnt.addColorStop(
                    0.5,
                    `rgba(${color_2[0]}, ${color_2[1]}, ${color_2[2]},${color_2[3] ? color_2[3] : "0.8"})`,
                );
                gnt.addColorStop(
                    0.8,
                    `rgba(${color_3[0]}, ${color_3[1]}, ${color_3[2]},${color_3[3] ? color_3[3] : "0.8"})`,
                );
                gnt.addColorStop(
                    1,
                    `rgba(${color_3[0]}, ${color_3[1]}, ${color_3[2]},${color_3[3] ? color_3[3] : "0.8"})`,
                );
            }

            ctx.fillStyle = gnt;
            ctx.fillRect(0, 0, this.w, this.h);
        }

        ctx.save();

        let imageData = ctx.getImageData(0, 0, this.w, this.h);

        Array.isArray(this.imgPix) &&
            this.imgPix.forEach((i: any) => {
                // 计算出这个点的坐标
                const x = (i / 4) % this.w;
                const y = Math.floor(i / 4 / this.w);
                const len = 2;
                imageData.data[i + 3] = 0;
                for (let j = x - len; j <= x + len; j++) {
                    // 横坐标
                    for (let k = y - len; k <= y + len; k++) {
                        // 纵坐标
                        let index = (k * this.w + j) * 4;
                        if (imageData.data[index]) {
                            imageData.data[index] = 255;
                            imageData.data[index + 1] = 255;
                            imageData.data[index + 2] = 255;
                            imageData.data[index + 3] = 0;
                        }
                    }
                }
            });

        ctx.putImageData(imageData, 0, 0);

        resolve(this.canvas.toDataURL("image/png"));
    };
}

function isEnclosedSpace(x: number, y: number, imageData: any) {
    const width = imageData.width;
    const height = imageData.height;
    const data = imageData.data;

    // 辅助函数，检查给定坐标是否是不透明的
    function isOpaque(nx: any, ny: any) {
        const index = (ny * width + nx) * 4;
        return data[index + 3] !== 0;
    }

    if (isOpaque(x, y)) {
        return false;
    }

    // 检查上侧是否有不透明像素
    let hasTopOpaque = false;
    for (let ty = y - 1; ty >= 0; ty--) {
        if (isOpaque(x, ty)) {
            hasTopOpaque = true;
            break;
        }
    }

    // 检查下侧是否有不透明像素
    let hasBottomOpaque = false;
    for (let by = y + 1; by < height; by++) {
        if (isOpaque(x, by)) {
            hasBottomOpaque = true;
            break;
        }
    }

    // 检查左侧是否有不透明像素
    let hasLeftOpaque = false;
    for (let lx = x - 1; lx >= 0; lx--) {
        if (isOpaque(lx, y)) {
            hasLeftOpaque = true;
            break;
        }
    }

    // 检查右侧是否有不透明像素
    let hasRightOpaque = false;
    for (let rx = x + 1; rx < width; rx++) {
        if (isOpaque(rx, y)) {
            hasRightOpaque = true;
            break;
        }
    }

    return hasTopOpaque && hasBottomOpaque && hasLeftOpaque && hasRightOpaque;
}
